import { Instance, SnapshotIn, types, flow, getEnv } from 'mobx-state-tree';

import { performGetEntity } from 'NeoAnalytics/services';
import { IStoresEnv } from '@core/storesEnv';

export const EntitiesInitialState = {
    id: '',
    actorsWhoExecuted: [],
    additionalData: {},
    averageDuration: '',
    companyId: '',
    completionCount: 0,
    createdAt: '',
    createdBy: '',
    description: '',
    executionCount: 0,
    lastDataUpdate: '',
    name: '',
    totalExecutionTime: '',
    type: '',
    updatedAt: '',
    updatedBy: '',
    versionsList: [],
}

export const EntitiesStoreInferred = types
    .model('EntitiesStoreInferred', {
        id: types.optional(types.string, ''),
        actorsWhoExecuted: types.array(types.string),
        averageDuration: types.optional(types.string, ''),
        companyId: types.optional(types.string, ''),
        completionCount: types.optional(types.number, 0),
        createdAt: types.optional(types.string, ''),
        createdBy: types.optional(types.string, ''),
        description: types.optional(types.string, ''),
        executionCount: types.optional(types.number, 0),
        lastDataUpdate: types.optional(types.string, ''),
        name: types.optional(types.string, ''),
        totalExecutionTime: types.optional(types.string, ''),
        type: types.optional(types.string, ''),
        updatedAt: types.optional(types.string, ''),
        updatedBy: types.optional(types.string, ''),
        versionsList: types.array(types.string),
    })
    .actions(self => {
        const { api } = getEnv<IStoresEnv>(self);

        const loadEntity = flow(function* (payload: any) {
            const result = yield performGetEntity(
                api,
                {
                    payload,
                    errorHandlers: { DEFAULT: '' },
                },
            );

            self = result;

            return result;
        });

        return {
            loadEntity,
        }
    })

type EntitiesStoreFactoryType = typeof EntitiesStoreInferred;
interface IEntitiesStoreFactory extends EntitiesStoreFactoryType { }
export const EntitiesStore: IEntitiesStoreFactory = EntitiesStoreInferred;
export interface IEntitiesStore extends Instance<IEntitiesStoreFactory> { }
export interface IEntitiesStoreSnapshotIn extends SnapshotIn<IEntitiesStore> { }
